import React from "react";
import classNames from "classnames";

import styles from "./styles.module.scss";
import {
  BuildingIcon,
  ClockBadgeIcon,
  CrossBadgeIcon,
  PlusBadgeIcon,
  ReviewDocIcon,
} from "./gateIcons";

export type ReviewCardVariant = "pending" | "rejected" | "onboarding";

interface Props {
  variant: ReviewCardVariant;
  title: string;
  /** Body copy. Pass a node when the design needs a line break inside the paragraph. */
  description: React.ReactNode;
  descriptionClassName?: string;
  /** Footnote row (pending) or call-to-action (rejected), rendered under the body copy. */
  children?: React.ReactNode;
}

/**
 * The status card shared by the gate screens (portal onboarding, pending, rejected): a large
 * glyph with a status badge, a headline, body copy, and a variant-specific footer.
 */
const OrganizationReviewCard: React.FC<Props> = ({
  variant,
  title,
  description,
  descriptionClassName,
  children,
}) => {
  const isRejected = variant === "rejected";
  const isOnboarding = variant === "onboarding";

  const Glyph = isOnboarding ? BuildingIcon : ReviewDocIcon;
  const Badge = isRejected
    ? CrossBadgeIcon
    : isOnboarding
    ? PlusBadgeIcon
    : ClockBadgeIcon;

  return (
    <div className={styles.reviewCard}>
      <span
        className={classNames(styles.reviewIcon, {
          [styles.rejected]: isRejected,
        })}>
        <Glyph className={styles.riDoc} />
        <span
          className={classNames(styles.reviewBadge, {
            [styles.rejected]: isRejected,
            [styles.onboarding]: isOnboarding,
          })}>
          <Badge />
        </span>
      </span>
      <h3>{title}</h3>
      <p className={descriptionClassName}>{description}</p>
      {children}
    </div>
  );
};

export default OrganizationReviewCard;
